import { useTranslation } from "react-i18next";
import "../../css/Menu/Menu.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import Signout from "../Signout/Signout";
import { AuthContext } from "../SessionChecker/SessionChecker";

function Menu({ theme, isSuperUser }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const location = useLocation();

  const { currentUserUsername } = useContext(AuthContext);

  return (
    <div className={`menuDiv ${theme}`}>
      <button
        className={`menuButton ${theme} ${location.pathname === "/" && "active"}`}
        onClick={() => {
          navigate("/");
        }}
      >
        <img src="/icons/home.png" className={`icon ${theme}`}></img>
        <div>{t("Home")}</div>
      </button>

      <button
        className={`menuButton ${theme} ${(location.pathname.startsWith("/search")) && "active"}`}
        onClick={() => {
          navigate("/search");
        }}
      >
        <img src="/icons/search.png" className={`icon ${theme}`}></img>
        <div>{t("Search")}</div>
      </button>

      <button
        className={`menuButton ${theme} ${location.pathname === "/swap" && "active"}`}
        onClick={() => {
          navigate("/add_product");
        }}
      >
        <img src="/icons/add.png" className={`icon ${theme}`}></img>
        <div>{t("Add Product")}</div>
      </button>

      <button
        className={`menuButton ${theme} ${location.pathname === "/notifs" && "active"}`}
        onClick={() => {
          navigate("/notifs");
        }}
      >
        <img src="/icons/notifs.png" className={`icon ${theme}`}></img>
        <div>{t("Notifications")}</div>
      </button>

      <button
        className={`menuButton ${theme} ${location.pathname === "/" + currentUserUsername && "active"}`}
        onClick={() => {
          navigate("/" + currentUserUsername);
        }}
      >
        <img src="/icons/profile.png" className={`icon ${theme}`}></img>
        <div>{t("Profile")}</div>
      </button>
    </div>
  );
}

export default Menu;
